import React from 'react';
import PropTypes from 'prop-types';
import GameMaintenance from './Maintenance/game';
import SiteMaintenance from './Maintenance/site';

export default function Maintenance({ site }) {
  return <React.Fragment>{site ? <SiteMaintenance /> : <GameMaintenance />}</React.Fragment>;
}

Maintenance.propTypes = {
  site: PropTypes.bool,
};

Maintenance.defaultProps = {
  site: false,
};
